import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEditor from './FormItemEditor';
import FormItemConst from './FormItemConst';
import {RecordFieldChangeStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import {UpdateDropDownContentStore,CmdUpdateShowDecimalStore} from '../stores/CmdTypeStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import Warning from '../utils/Warn';
import FormItemDecimalResolver from './resolver/FormItemDecimalResolver';
import FormItemDecimalDisplay from './display/FormItemDecimalDisplay';

export default class FormItemDecimalEditor extends FormItemEditor
{

	constructor(props) {
		super(props);
		this.initMembers();
		this.initStores();

		this.state.dropDownContent = this.props.dropDownContent || this.props.control.dropDownContent || this.props.control.getProperty_DropDownContent();
	}

	initMembers()
	{

	}

	initStores()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
			this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
			this.unsubcribeCmdUpdateControlVisibleStore = CmdUpdateShowDecimalStore.listen(this.onCmdUpdateShowDecimal.bind(this));

		}
	}

	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name)
		{
			
			this.setState({dropDownContent:type});
			
		}
		
	}
	onCmdUpdateShowDecimal(name,_value,moduleInstanceId){
		if(this.props.moduleInstanceId == moduleInstanceId && name == this.props.xml.name)
		{
			if(!window.doUpformItemShowDecimalValueMap){
				window.doUpformItemShowDecimalValueMap={};
				window.doUpformItemShowDecimalValueMap[name]=_value;
			}else{
				window.doUpformItemShowDecimalValueMap[name]=_value;
			}
			this.setState({});
		}
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore();
			this.unsubscribeAutoSaveBeforeStore();
		}
		this.inputField.removeEventListener("mousewheel",this.stopScrollFun.bind(this),{passive:false});
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
	}


	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;			
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			this.setDisplay(_value);

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	componentDidMount()
	{
		super.componentDidMount();
		 //此处跟Flex有差别 无法精确判断焦点关联对象 relatedTarget只有在文本框类dom节点才有值 否则为null
		 //不能获得焦点的比如下拉框div仍然可以使得input失去焦点
		 /*$(this.refs.inputdomtime).blur(function(event){
		 	  
		  	  $(this).val("06-06");
		 });*/
		if(this.props.underQueryGroup)
		{

			this.doSetEnable(false);

		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		}
		
		$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
		this.inputField.addEventListener("mousewheel",this.stopScrollFun.bind(this),{passive:false});
		
	}

	labelClickHandler()
	{

	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}
	}

	setDisplayError()
	{
		
	}

	onBeforeAutoSave(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			if($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length)
			{
				let text = $(this.inputField).val();
				let _val;
				try
				{
					_val = FormItemDecimalResolver.getResult(text,false,this.props.allowNegative,this.props.numOfDecimals,this.props.roundOff);	
				}
				catch(e)
				{
					alert(e.message);
					return;
				}

				if(_val.indexOf("false:") == 0)
				{					
					return false;
				}
				if(this.props.groupAlias == "")
				{
					this.record = _val;
				}
				else
				{
					let changed = false;
					let oldValue = this.record[this.props.dataField];
					let newValue = _val;
					if(oldValue != newValue)
						changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if(changed)
					{
						RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
						if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
					}
					this.updateModifiedTag();			
				}
			}
		}
		return true;
		
	}

	setFinalValue(value,triggerModified = true)
	{
		if(this.props.underQueryGroup){
			var reg = "^[ ]+$";
			var rege = new RegExp(reg);
			if(rege.test($(this.inputField).val())){
				$(this.inputField).val('-只查空值-');
				this.record = '-只查空值-';
				this.state.nullValue = true;
				value='-只查空值-';
			}else if($(this.inputField).val() == '-只查空值-' || $(this.inputField).val()=='-'){
				$(this.inputField).val('-只查空值-');
				value='-只查空值-';
			}else if(value=='-点此填值-'){
				$(this.inputField).val('-点此填值-');
				value='';
			}else{
				if(typeof(value) != "number" && (value == "" || value == null || value == undefined))
				value = $(this.inputField).val();
		
			value = FormItemDecimalResolver.getResult(value,false,this.props.allowNegative,this.props.numOfDecimals,this.props.roundOff);	
			}
		}else{
		if(typeof(value) != "number" && (value == "" || value == null || value == undefined))
			value = $(this.inputField).val();
	
		//try
		//{
			value = FormItemDecimalResolver.getResult(value,false,this.props.allowNegative,this.props.numOfDecimals,this.props.roundOff);	
		//}
		//catch(e)
		//{
		//	alert(e.message);
		//	return;
		//}

		}
		
		if(value.indexOf("false:") == 0)
		{
			Warning.show({text:value.substr(6)});
			return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
		}
		if(!this.props.dataField)
		{
			var oldValue = this.record;
			this.record = value;
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue, this);
				}
			}
		}
		else
		{
			let changed = false;

			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			if(this.record&&this.record.hasOwnProperty(this.props.dataField))this.record[this.props.dataField] = newValue;

			//alert("派发");	
			if(changed)
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"",null,this);
			}
			this.updateModifiedTag();			
		}
		return FormItemConst.EDITOR_VALUE_CHANGED_SUC;
	}

	//新版框架为了避免复杂判断 该类仅表示Form上的FormItem
	inputFieldBlur()
	{
		if(this.props.underQueryGroup && $(this.inputField).val()==""){
			this.state.notNull = false
			this.setState({allowEdit:false,nullValue:false})
			this.inQueryGroup = false;
		}else{		
		//if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
			if(this.state.allowEdit)
			{
				this.setFinalValue();
				//todo 值回送数据完成以后 严格按照显示要求再进行显示
				this.setDisplay();
			}
		}
		if(this.holdFocus)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}

	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		this.inQueryGroup = false;
	}
	textOnChange(){
		// this.state.nullValue = false
		// let nowTxt = $(this.inputField).val();
		// if(this.state.underQueryGroup){
		// 	var reg = "^[ ]+$";
		// 	var rege = new RegExp(reg);
		// 	if(rege.test(nowTxt)){
		// 		$(this.inputField).val('-只查空值-');
		// 		this.record = '-只查空值-';
		// 		this.state.nullValue = true;
		// 	}
		// }
	}
	inputFieldOnClick(){
		if(this.props.underQueryGroup){
			this.state.notNull = false
			this.setState({allowEdit:true,nullValue:false})
			this.inQueryGroup = true;
		}
	}

	restoreValue(_value)
	{
		let that = this;
		
		if(!this.props.dataField)
		{
			this.record = _value;
		}
		else if(this.record)
		{
			this.record[this.props.dataField] = _value;
		}
		this.setDisplay();
		this.updateModifiedTag();
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}

		if(value == null)
			value = "";
		if(value != "")
		{
			let parms = {};
			if(this.props.displayStyle)
			{
				let _displayStyle = this.props.displayStyle;
				if(_displayStyle.IsPercent == true)
				{
					parms.type = "percent";
				}
				else if(_displayStyle.CurrencyPrefix)
				{
					parms.type = "prefix";
					parms.prefix = _displayStyle.CurrencyPrefix;
				}
				else
				{
					parms.type = "normal";
				}
			}

			let sname = this.props.xml.name;
			if(window.doUpformItemShowDecimalValueMap && window.doUpformItemShowDecimalValueMap[sname]){
				value = FormItemDecimalDisplay.getDisplayText(value,this.props.showZero,window.doUpformItemShowDecimalValueMap[sname],this.props.thousandSeperator,parms);
			}else{
				value = FormItemDecimalDisplay.getDisplayText(value,this.props.showZero,this.props.showDecimals,this.props.thousandSeperator,parms);
			}

		}

		$(this.inputField).val(value);
	}

	inputFieldFocus()
	{
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
		if(this.props.underQueryGroup && this.record=='0.00'){
			this.record="";
		}
		if(!this.props.dataField)
		{
			$(this.inputField).val(this.record);
		}
		else
		{
			let _recordValue = this.record==null?"":this.record[this.props.dataField];
			$(this.inputField).val(_recordValue);	
		}
		if(this.state.underQueryGroup){
			if($(this.inputField).val() == '-只查空值-'){
				$(this.inputField).val('');
				this.record='';
			}
		}
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	onKeyUpHandler(e)
	{
		let _val = $(this.inputField).val();
		$(this.inputField).val(_val.replace(/[^\-?\d.]/g,''));
	}

	onKeyPressHandler(event)
	{
		return (/[\d|\.|\-]/.test(String.fromCharCode(event.charCode)));
	}

	stopScrollFun(evt) 
	{  
		evt = evt || window.event;  
		if(evt.preventDefault)
		{  
			// Firefox  
			evt.preventDefault();  
			evt.stopPropagation();  
		} 
		else 
		{  
			// IE  
			evt.cancelBubble=true;  
			evt.returnValue = false;  
		}  
		return false;  
	}

	onKeyDownHandler(e)
	{
		if(super.onKeyDownHandler(e))
			return;
		
		if(!e.ctrlKey && (e.keyCode>64&&e.keyCode<91))
		{
			e.preventDefault();
		}
	}

	onKeyUpHandler(e)
	{
		if(this.inputField.value)
		{

			var reg = "^[ ]+$";
			var rege = new RegExp(reg);
			if(rege.test(this.inputField.value)){
				this.inputField.value = " ";
				$(this.inputField).val(" ");
			}else
				if(this.inputField.value.length==1)
			{
				this.inputField.value=this.inputField.value.replace(/[^0-9\-\.]/g,'');
			}else{
				this.inputField.value=this.inputField.value.replace(/^[^\d.]+$/g,'');
				return;
				let isNegtive = this.inputField.value.indexOf("-") == 0;
				if(isNegtive)
				{
					this.inputField.value = "-"+this.inputField.value.replace(/^[^\d.]+$/g,'');//(/\D/g,'');
				}
				else
				{
					this.inputField.value=this.inputField.value.replace(/^[^\d.]+$/g,'');

			}
			}
		}
		
	}

	getInputDom(_width,cacltagdom)
	{
        if(this.state.allowEdit)
        {
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
        	let _style = {padding:'2px',height:(height)+'px',width:_width,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			_style.imeMode="disabled";
			if(this.state.dropDownContent != FormItemConst.DECIMALEDITOR_DROPDOWN_NONE)
				_style.paddingRight = "13px";
        	if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
			//if(cacltagdom)_style.paddingRight = "17px";
			if(this.props.underQueryGroup){
				_style.border ='none'
				_style.height =parseInt(height)-2+'px';
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+5+'px';
				return <div style={{position:'relative',width:'100%',height:'100%',marginRight:'12px',border:'1px solid #ccc'}} >
					<input spellCheck="false"  autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id}
					className="form-control" style={_style} onKeyUp={this.onKeyUpHandler.bind(this)} onChange={this.textOnChange.bind(this)}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
					<i className="fa fa-times-circle" style={{position: 'absolute',right: '1px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	

				</div>
				
			}else{
				return <input spellCheck="false"  autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id}
				className="form-control" style={_style} onKeyUp={this.onKeyUpHandler.bind(this)}
				onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>
			}

        }
        else
        {
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
        	let _style = {padding:'2px',height:(height)+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();_style.imeMode="disabled";
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
        	if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);

			if(this.props.underQueryGroup){
				_width = _width.replace('px','');
				_style.width=parseInt(_width)+19+'px';
				let defaultValue='-点此填值-';
				_style.textAlign='center';
				return	<div>
					<input spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text" readOnly="readonly"
			        	   className="form-control" style={_style}
			        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)} value={defaultValue} onClick={this.inputFieldOnClick.bind(this)} />
					</div>

			}else{
				return <input spellCheck="false"  autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id}
				className="form-control" style={_style} 
				onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}  onClick={this.inputFieldOnClick.bind(this)} readOnly="readonly"/>
			}
        }
	}

	calculatorReturnHandler(result)
	{
		if(result && this.state.allowEdit)
		{
			this.setFinalValue(result);
			//值回送数据完成以后 严格按照显示要求再进行显示
			this.setDisplay();
		}

		$(this.inputField).focus();
		$(this.inputField).select();
	}

	showCalculator()
	{
		window.parent.window.showCaculator("clear",this.calculatorReturnHandler.bind(this));
	}

	showNumKeyBoard()
	{
		var _offset1 = $(this.inputField).offset();
		var _offset2 = $(window.frameElement).offset();
		var _inputwidth = $(this.inputField).width();
		var _inputheight = $(this.inputField).height()+7;
		window.parent.window.showNumKeyBoard("clear",_offset1,_offset2,_inputwidth,_inputheight,this.calculatorReturnHandler.bind(this));

		$(window.parent.document).find("#jqcalculator_percentage").css('display','block');
		$(window.parent.document).find("#jqcalculator_decimal").css('display','block');

	}

	getCacltagdom()
	{
		let display = "none";
		if(this.state.dropDownContent == FormItemConst.DECIMALEDITOR_DROPDOWN_CACL)
		{
			display = "block";
		}
		return <i className="fa fa-calculator" onClick={this.showCalculator.bind(this)} style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',display:display}}></i>;
	}

	getNumKeyBoardDom()
	{
		let display = "none";
		if(this.state.dropDownContent == FormItemConst.DECIMALEDITOR_DROPDOWN_NUMKEYBOARD)
		{
			display = "block";
		}
		return <i className="fa fa-keyboard-o" onClick={this.showNumKeyBoard.bind(this)} style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',display:display}}></i>;
	}

	render()
	{
		let inputWidth = this.props.displayLengthWidth + "px";
		let _display = this.currentDataFieldChanged?"block":"none";
		let displayLength=this.state.displayLength;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";
		let cacltagdom = this.getCacltagdom();
		let keyborddom = this.getNumKeyBoardDom();
		let widthProValue = this.props.control.getProperty_Width();
		let middleStyle = {position:"relative"};
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
		}

		let inputdom = this.getInputDom(_width,cacltagdom);
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		// if(this.state.underQueryGroup && !this.inQueryGroup)
		// {
		// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		// }
		if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"};
		let _displayStyleClassName = "editorGroup";
		if(this.props.displayStyle)
		{
			if(this.props.displayStyle._class)
			{
				_displayStyleClassName += (" "+this.props.displayStyle._class);
			}
		}
		return(

			<div ref={node=>this.contextMenuHandler=node} id={this.props.xml.name} className={_displayStyleClassName} style={editorStyle}>
				<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
					{this.state.label}
					 
				</label>
				<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
				<div style={middleStyle}>
				   {inputdom}
				   {cacltagdom}
				   {keyborddom}
			       <i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
			    </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemDecimalEditor.js